import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { products } from '../data/products';
import './ProductDetail.css';

const ProductDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { addToCart } = useCart();
  const product = products.find(p => p.id === parseInt(id));

  const [selectedSize, setSelectedSize] = useState('');
  const [selectedImage, setSelectedImage] = useState(0);
  const [addedToCart, setAddedToCart] = useState(false);

  if (!product) {
    return (
      <div className="product-not-found container">
        <h2>Product not found</h2>
        <button onClick={() => navigate('/shop')} className="back-button">
          Back to Shop
        </button>
      </div>
    );
  }

  const handleAddToCart = () => {
    if (!selectedSize) {
      alert('Please select a size');
      return;
    }

    addToCart(product, selectedSize);
    setAddedToCart(true);
    setTimeout(() => setAddedToCart(false), 2000);
  };

  return (
    <div className="product-detail">
      <div className="container">
        <button onClick={() => navigate('/shop')} className="back-link">
          ← Back to Shop
        </button>

        <div className="product-detail-content">
          <div className="product-images">
            <div className="main-image">
              <img
                src={product.images?.[selectedImage] || product.image}
                alt={product.name}
              />
              {product.featured && (
                <span className="featured-badge">Featured</span>
              )}
            </div>
            {product.images && product.images.length > 1 && (
              <div className="image-thumbnails">
                {product.images.map((img, index) => (
                  <button
                    key={index}
                    className={`thumbnail ${selectedImage === index ? 'active' : ''}`}
                    onClick={() => setSelectedImage(index)}
                  >
                    <img src={img} alt={`${product.name} view ${index + 1}`} />
                  </button>
                ))}
              </div>
            )}
          </div>

          <div className="product-details">
            <h1 className="product-title">{product.name}</h1>
            <p className="product-title-jp">{product.nameJp}</p>
            
            <div className="product-price-section">
              <span className="product-price">¥{product.price.toLocaleString()}</span>
              <span className="product-category-badge">{product.category}</span>
            </div>

            <div className="product-description">
              <p>{product.description}</p>
              <p className="description-jp">{product.descriptionJp}</p>
            </div>

            <div className="product-options">
              <div className="size-selector">
                <label className="option-label">
                  Select Size <span className="label-kanji">サイズ</span>
                </label>
                <div className="size-buttons">
                  {product.sizes.map(size => (
                    <button
                      key={size}
                      className={`size-button ${selectedSize === size ? 'active' : ''}`}
                      onClick={() => setSelectedSize(size)}
                    >
                      {size}
                    </button>
                  ))}
                </div>
              </div>

              <div className="color-info">
                <label className="option-label">
                  Available Colors <span className="label-kanji">カラー</span>
                </label>
                <div className="color-list">
                  {product.colors.map((color, index) => (
                    <span key={index} className="color-item">{color}</span>
                  ))}
                </div>
              </div>
            </div>

            <button
              className={`add-to-cart-button ${addedToCart ? 'added' : ''}`}
              onClick={handleAddToCart}
            >
              {addedToCart ? '✓ Added to Cart' : 'Add to Cart'}
              <span className="button-kanji">
                {addedToCart ? 'カートに追加されました' : 'カートに追加'}
              </span>
            </button>

            <div className="product-features">
              <h3>Product Features</h3>
              <ul>
                <li>Premium quality materials</li>
                <li>Traditional Japanese craftsmanship</li>
                <li>Modern streetwear fit</li>
                <li>Limited edition collection</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetail;
